import { useEffect } from 'react';
import { useDatalayerTracking } from '@edreamsodigeo/frontend-core';

export const useTrackTMSPage = (label) => {
  const { save: saveDatalayer } = useDatalayerTracking();
  useEffect(() => {
    saveDatalayer({
      page_name: label,
      env_template: label,
    });
  }, [label, saveDatalayer]);
};

export const trackTMSSelectedOffer = (offerType, saveDatalayer) => {
  saveDatalayer({
    prime_benefit: `${offerType === 'PRIME' ? 'true' : 'false'}`,
    user_prime_subscription: `${
      offerType === 'PRIME' ? 'subscriber' : 'non_subscriber'
    }`,
    user_prime_subscription_type: `${
      offerType === 'PRIME'
        ? 'free-trial-plus-1-months'
        : 'free-trial-permitted'
    }`,
  });
};

export const useResetTMSTracking = (isPrime) => {
  const { save: saveDatalayer } = useDatalayerTracking();
  useEffect(() => {
    if (isPrime) return;
    saveDatalayer({
      prime_benefit: 'false',
      user_prime_subscription: 'non_subscriber',
      user_prime_subscription_type: 'free-trial-permitted',
    });
  }, [isPrime, saveDatalayer]);
};
